module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main column",
    attrs: {
      "id": "app"
    }
  }, [_c('my-header', {
    on: {
      "notif-open": function($event) {
        _vm.notifPanelActive = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page column"
  }, [_c('router-view')], 1), _vm._v(" "), _c('notification-panel', {
    attrs: {
      "active": _vm.notifPanelActive
    },
    on: {
      "notif-close": function($event) {
        _vm.notifPanelActive = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d772cde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 631
// module chunks = 1